/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import ActivityLog from "layouts/activityLog/activityLog";
import { useEffect, useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { appConstants } from "utils/appConstants";
import DownloadIcon from '@mui/icons-material/Download';
import { fetchInvoicePdfTheme } from "utils/api";
import { generateDataList } from "utils/generic";
import { showResMsg } from "utils/generic";
import { useDispatch } from "react-redux";
import InvoiceModal from "components/invoiceModal/invoiceModal";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { downloadInvoice } from "utils/api";
import { AllKeysHaveValue } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import { ResendEmail } from "utils/invoiceAPI";
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%x",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "#202940",
    },
    context: {
      background: "#202940",
      text: "white",
    },
    divider: {
      default: "white",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);

function ViewInvoices() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent = "Records Per Page";
  }
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const { id: InvoiceID } = useParams();
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [loading, setLoading] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [retentionItemValues, setRetentionItemValues] = useState([]);
  const [showInvoiceSection, setShowInvoiceSection] = useState(false);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemName: "", itemPrice: "", itemQuantity: "", categoryCodeName: "", gst: "", priceValidity: "None",
      priceValidityValue: "", discountType: "None", discountValue: "", discountAmount: ""
    },
  ]);
  const [displayDialogeFlag, setDisplayDialogeFlag] = useState(false);
  const [themeName, setThemeName] = useState([]);
  const [themeValues, setThemeValues] = useState({
    _id: InvoiceID,
    themeID: ""
  })
  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "Invoices",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [currencyCode, setCurrencyCode] = useState("");
  const [values, setValues] = useState({
    quotationID: undefined,
    invoiceID: "",
    invoiceNumber: 'Auto Generated',
    contactID: '',
    purchaseOrderNumber: '',
    invoiceDate: new Date(),
    validUpto: "Same Day",
    validUptoDate: new Date(),
    invoiceStatus: 'Unpaid',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    finalAmount: 0,
    paymentInstruction: '',
    sendEmailFlag: false,
  })
  const [quoDocuments, setDocuments] = useState([]);

  console.log(InvoiceID)
  useEffect(() => {
    const fetchData = async () => {
      await FetchPendingInvoiceForCustomer();
    };
    fetchData();
  }, []);


  const handleEmailQuotation = async () => {
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      await getEmailAndTemplateForQuotation({ screenType: templateValues.screenType, contactID: values.contactID, selectedID: InvoiceID, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
        console.log("data", data)
        if (data.Result_Status) {
          console.log("email", data.Result_Status)
          setTemplateValues(data.Result_Output);
          setOpen(true);
        } else {
          showResMsg(data.Result_Message, 2000, false);
          setOpen(false);
        }
      }, dispatch);
    }
  }

  // const handleResendEmail = async (selectedRow) => {
  //   if (AllKeysHaveValue(templateValues)) {
  //     setOpen(true);
  //   } else {
  //     await getEmailAndTemplateForQuotation({ screenType: templateValues.screenType, contactID: selectedRow.contactID, selectedID: selectedRow._id, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
  //       if (data.Result_Status) {
  //         setTemplateValues(data.Result_Output);
  //         setOpen(true);
  //       } else {
  //         showResMsg(data.Result_Message, 2000, false);
  //         setOpen(false);
  //       }
  //     }, dispatch);
  //   }
  // }

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };
  const handleSend = (templateData) => {

    let payload = {
      selectedID: templateData.selectedID,
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
    };
    ResendEmail({ payload }, (data) => {
      let status = data.Result_Status;
      showResMsg(data.Result_Message, 2000, status);
      // fetchInvoices();
    }, dispatch);
    values.sendEmailFlag = true;
    values.templateValues = payload;
    setOpen(false)
  }

  const FetchPendingInvoiceForCustomer = async () => {
    setLoading(true)
    await axios.post(appConstants.baseURL + 'invoice/viewInvoiceByID', { invoiceID: InvoiceID }).then(res => {

      console.log("res in view invoice by id", res);
      let data = res.data.Result_Output[0] || {};
      console.log("res.data.Result_Status", res.data.Result_Status);
      if (res.data.Result_Status) {

        let data = res.data.Result_Output;

        setShowInvoiceSection(true);
        data.length > 0 && setValues(data[0]);
        setCurrencyCode(data[0].currencyValue);
        data[0].itemsList?.length > 0 && setItemRowValues(data[0].itemsList);
        data[0].documentsList?.length > 0 && setDocuments(data[0].documentsList);
        data[0].invoicePayment?.length > 0 && setPaymentHistory(data[0].invoicePayment)
        data[0].retentions?.length > 0 && setRetentionItemValues(data[0].retentions);
      } else {
        console.log("res.data.Result_Status", res.data.Result_Status);
        setCurrencyCode(data.currencyValue);
        setValues(data);
        // showResMsg(res.data.Result_Message, 2000, res.data.Result_Status, navigate, '/invoices');
      }
      setLoading(false);
    }).catch(error => {
      console.error("Error in fetchPendinginvoiceForCustomer: ", error);
    })
  }

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
        minHeight: '30px'
      },
    },
    headCells: {
      style: {
        paddingLeft: "5px",
        paddingRight: "5px",
        fontSize: "12px",
        color: "white",
      },
    },
  };
  let columns = [
    {
      name: "Item Name",
      selector: row => row.itemName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Description",
      selector: row => row.itemDescription,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px", textAlign: "center" },
    },
    {
      name: "Qty",
      selector: row => row.itemQuantity,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Item Price (${currencyCode})`,
      selector: row => row.itemPrice,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Account",
      selector: row => row.categoryCodeName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px", textAlign: "center" },
    },
    {
      name: "GST(%)",
      selector: row => row.gst,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    // {
    //   name: "Discount Type",
    //   selector: row => row.discountType,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
    // {
    //   name: "Discount Value",
    //   selector: row => row.discountValue,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },

  ];
  // let columns = [
  //   {
  //     name: "Item Name",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         value={row.itemName}
  //         variant="outlined"
  //         disabled
  //         fullWidth
  //       />

  //     ),
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //       display: "block"
  //     },
  //   },
  //   {
  //     name: "Item Price",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         value={row.itemPrice}
  //         variant="outlined"
  //         disabled
  //         fullWidth

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "Item Quantity",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         value={row.itemQuantity}
  //         variant="outlined"
  //         disabled
  //         fullWidth

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "GST%",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.gst}
  //         disabled
  //         style={{ cursor: 'default', pointerEvents: 'none' }}

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "Discount Type",
  //     selector: (row, i) => (
  //       <Select
  //         style={{ height: "35.25px" }}
  //         labelId="day-hours-select-label"
  //         id="day-hours-select"
  //         value={row.discountType}
  //         disabled
  //         fullWidth
  //         variant="outlined"
  //       >
  //         <MenuItem value="None">None</MenuItem>
  //         <MenuItem value="Percentage">Percentage %</MenuItem>
  //         <MenuItem value="Fixed">Fixed</MenuItem>
  //       </Select>
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px", display: "block"
  //     },
  //   },
  //   {
  //     name: "Discount Value",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.discountType === "None" ? 0 : row.discountValue}
  //         disabled

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "Discount Amount($)",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.discountType === "None" ? 0 : row.discountAmount}
  //         disabled

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },

  // ];

  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
    setViewDocumentInModal(true);
  };


  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action",
      selector: (row) => row,
      center: true,
      cell: (row) => (
        <>
          <Grid item mt={-3}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => { handleViewDocument(row) }}
              title="View"
            />
          </Grid>


        </>
      ),
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: false,
  };

  const paymentColumns = [

    {
      name: "Payment Date",
      selector: (row) => row.paymentDate,
      sortable: true,
      sortField: "paymentDate",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Payment Mode",
      selector: (row) => row.paymentMode,
      sortable: true,
      sortField: "partialPayment",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Transaction ID",
      selector: (row) => row.paymentTransactionID,
      sortable: true,
      sortField: "paymentTransactionID",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Payment Type",
      selector: (row) => row.paymentType,
      sortable: true,
      sortField: "paymentType",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Payment Amount (${currencyCode})`,
      selector: (row) => row.paymentAmount,
      sortable: true, center: true,
      sortField: "paymentAmount",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Pending Amount (${currencyCode})`,
      selector: (row) => row.pendingAmount,
      sortable: true,
      sortField: "pendingAmount",
      center: true,
      style: { paddingLeft: "10px", },
    },

  ];
  let columnRetention = [
    {
      name: "Retention No.",
      selector: row => row.retentionNumber,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Payment Status`,
      selector: row => row.retentionStatus,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Retention Due Date`,
      selector: row => row.retentionDueDate,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Payment Amount (${currencyCode})`,
      selector: row => parseFloat(row.retentionPaymentAmount).toFixed(2),
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
  ];
  const fetchThemeAndDownload = () => {
    fetchInvoicePdfTheme({ businessUserID: loginDetails.businessUserID }, async (data) => {
      if (data.Result_Output.length > 0) {
        themeValues.themeID = data.Result_Output[0]._id;
        const themeListMenu = await generateDataList(data.Result_Output, "_id", "themeName");
        if (themeListMenu.length > 0) {
          setThemeName(themeListMenu);
          setDisplayDialogeFlag(true);
        } else {
          showResMsg("Branding Theme couldn't found, Please try again!", 2000, false);
        }
      } else {
        showResMsg("Branding Theme couldn't found, Please try again!", 2000, false);
      }
    }, dispatch);
  }
  const handleCancel = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setDisplayDialogeFlag(false);
  };
  const handleDownload = async (event) => {
    setDisplayDialogeFlag(false);
    await downloadInvoice(themeValues, async (response) => {

      const pdfContent = response.data;
      const binaryPdfData = atob(pdfContent);

      const arrayBuffer = new ArrayBuffer(binaryPdfData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryPdfData.length; i++) {
        uint8Array[i] = binaryPdfData.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      ShowSwalWithButtons(
        'Are you sure?', `Would you like to download the Invoice?`, 'question', darkMode,
        () => {
          const link = document.createElement('a');
          link.href = url;
          link.download = 'invoice.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      );
    }, dispatch)

  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary" sx={{ pb: "10px" }}>

          <PageTitle screenName="View Invoice" />
          <Grid container px={2} mt={2} spacing={2}>
            {/* invoice Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Number"
                variant="outlined"
                disabled
                fullWidth
                value={values.invoiceNumber}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Customer"
                variant="outlined"
                disabled
                fullWidth
                value={values.contactName}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Reference Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Reference Number "
                variant="outlined"
                placeholder="Optional"
                fullWidth
                value={values.purchaseOrderNumber}
                inputProps={{
                  className: "custom-fieldtext",
                  maxLength: 50
                }}
                InputLabelProps={{ shrink: true }}

                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Date"
                variant="outlined"
                fullWidth
                value={values.invoiceDate}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            {/* validUpto */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Upto"
                variant="outlined"
                fullWidth
                value={values.validUpto}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Date"
                variant="outlined"
                fullWidth
                value={values.dueDate}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"

                  style={{ height: "35.11px" }}

                  disabled
                  label="Status"
                  value={values.invoiceStatus}

                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Partial Paid">Partial Paid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>

          </Grid>
          <CardContent>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="210px"
              fixedHeader={true}
            />
          </CardContent>
          <Grid container px={2} pt={2} pb={2} spacing={2}>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"

                  style={{ height: "35.11px" }}

                  label="GST Type"
                  value={values.gstType || 'Inclusive'}
                  disabled
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Total Amount(${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalAmount}

              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Total Discount Amount(${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalDiscountAmount}

              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Final Amount(${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.finalAmount}

              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                value={values.paymentInstruction}
                disabled

              />
            </Grid>
          </Grid>

          {quoDocuments.length > 0 &&
            <CardContent>
              <DataTable
                theme={darkMode ? "solarized" : "light"}
                columns={documentColumns}
                data={quoDocuments}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />
            </CardContent>
          }
          <Stack spacing={2} mt={2} pb={3} direction="row" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
            <Button variant="outlined" size="small" style={{ fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", color: '#1ed6c9', borderRadius: "5px", }} onClick={() => { navigate('/invoices') }}>
              Close
            </Button>

            <Button variant="outlined" size="small" style={{
              fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", borderRadius: "5px", color: '#1ed6c9'
            }}
              onClick={fetchThemeAndDownload}
            >
              <DownloadIcon sx={{ marginRight: "5px" }} /> Print / Download
            </Button>
            <Button variant="outlined" size="small" style={{
              fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", borderRadius: "5px", color: '#1ed6c9'
            }}
              onClick={handleEmailQuotation}
            >
              Send Email
            </Button>
          </Stack>

        </Card>

        <div >
          <Card style={{ marginTop: "20px" }}>
            <ActivityLog name="Invoice" />
          </Card>
        </div>

        {(retentionItemValues.length > 0 || paymentHistory.length > 0) &&
          <Card color="success" sx={{ mt: 2 }}>
            <Grid item px={2} pt={1} xs={12} md={4} lg={12} >
              <p style={{ fontSize: "14px", fontWeight: "bold", color: "#008000" }} >Invoice Payment Details</p>
            </Grid>

            <CardContent sx={{ mb: 2 }}>
              {paymentHistory.length > 0 && <DataTable
                theme={darkMode ? "solarized" : "light"}
                columns={paymentColumns}
                data={paymentHistory}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />}
              {retentionItemValues.length > 0 && <DataTable
                theme={darkMode ? "solarized" : "light"}
                columns={columnRetention}
                data={retentionItemValues}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />}
            </CardContent>
          </Card>
        }
      </div>

      <Modal
        open={viewDocumentInModal}
        onClose={() => setViewDocumentInModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          '& .MuiModal-root': {
            width: '100%',
            height: '100%',
          },
        }}
      >
        <Card sx={pdfStyle}>
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Invoice Document Viewer
            </Typography>
            <iframe title="Invoice Document Viewer" src={getDocumentFileURL} width="100%" height="650" frameborder="0" allowfullscreen={true}></iframe>

            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>

                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>
      {
        displayDialogeFlag && <InvoiceModal
          open={displayDialogeFlag}
          handleSave={handleDownload}
          handleAdd={() => { navigate(`/invoicePdfFormat/addInvoicePdfFormat?new=invoice&ref=${values.invoiceNumber}&id=${InvoiceID}`) }}
          handleCancel={handleCancel}
          menuData={themeName}
          value={themeValues.themeID}
          onChange={(e) => setThemeValues({ ...themeValues, themeID: e.target.value })}
        />
      }
      <LoadingModal loading={loading} />

      {open && <EmailTemplateModal
        open={open}
        handleClose={handleClose}
        templatesData={templateValues}
        onSend={handleSend}
      />}
    </DashboardLayout>
  );
}

export default ViewInvoices;
